var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_5857_397)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41707 9.99992L12.0029 13.5857L15.5887 9.99992C15.9792 9.6094 16.6123 9.6094 17.0029 9.99992C17.0517 10.0487 17.0944 10.1013 17.131 10.1568C17.3873 10.5449 17.3446 11.0724 17.0029 11.4141L12.71 15.707C12.5224 15.8945 12.2681 15.9999 12.0029 15.9999C11.7376 15.9999 11.4833 15.8945 11.2958 15.707L7.00285 11.4141C6.61233 11.0236 6.61233 10.3904 7.00285 9.99992C7.05167 9.95111 7.10428 9.90839 7.15973 9.87178C7.54788 9.6155 8.07536 9.65821 8.41707 9.99992Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5857_397",
    x1: 0,
    y1: 0,
    x2: 22.9091,
    y2: 23.2727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630311,
    stopColor: "#01CFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D3CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqArrow);
export default __webpack_public_path__ + "static/media/faq-arrow.43783b1ff62413cc8bd069237a843c13.svg";
export { ForwardRef as ReactComponent };